<template>
  <thank-you :recList="recommendedWebinarsFormatted" type="webinars" />
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import ThankYou from "@/views/plus/thankYou/shardComponents/ThankYou";

export default {
  name: "webinars",
  components: { ThankYou },
  data() {
    return {
      recommendedWebinarsFormatted: []
    };
  },
  created() {
    this.getRecommendedWebinars().then(() => this.organizeRecommendation());
  },
  computed: {
    ...mapState("webinars", ["recommendedWebinars"])
  },
  mounted() {
    this.hideComponentMountLoader();
  },
  methods: {
    ...mapMutations(["hideComponentMountLoader"]),
    ...mapActions("webinars", ["getRecommendedWebinars"]),
    organizeRecommendation() {
      this.recommendedWebinarsFormatted = [];
      for (let i = 0; i <= 2; i++) {
        const webinar = this.recommendedWebinars[i];
        let secondaryText = window.matchMedia("(max-width: 768px)").matches
          ? webinar.hosted_by.name
          : "";
        this.recommendedWebinarsFormatted.push({
          title: webinar.title,
          text: secondaryText,
          img: webinar.image,
          item_id: webinar.friendly_url
        });
      }
    }
  }
};
</script>

<style scoped></style>
